<template v-if="href">
  <a-link-v2
    :url="href"
    :class="[name, `${name}__link`, { over: active }]"
    @mouseover.native="onCardHover(true)"
    @mouseleave.native="onCardHover(false)"
  >
    <grid
      :class="[`${name}__grid`]"
      :layout="[
        {
          size: 1,
          columns: 'repeat(12, 1fr)',
          gap: '6px',
        },
        {
          size: 2,
          columns: 'repeat(24, 1fr)',
          gap: '10px',
        },
      ]"
    >
      <grid-item
        :class="[`${name}__grid-item`]"
        :layout="[
          { size: 1, x: 1, width: 12 },
          { size: 3, x: 1, width: 24 },
        ]"
      >
        <transition name="fade">
          <a-image-v2
            v-if="(cms.image || {}).filename"
            :src="cms.image.filename"
            :alt="cms.image.alt"
            :layout="layout"
            :class="`${name}__image`"
          />
        </transition>
        <div :class="`${name}__content`">
          <div v-if="published" :class="`${name}__date`">
            {{ $dateFns.format(new Date(published), 'dd / MMMM / yyyy') }}
          </div>
          <a-eyebrow
            v-if="cms.eyebrow"
            :cms="cms"
            :class="`${name}__eyebrow`"
          />
          <a-heading
            v-if="cms.heading"
            html-tag="h4"
            :cms="cms"
            :class="`${name}__heading`"
          />
          <a-cta-v2
            :cms="{
              copy: 'Read more.',
              type: 'secondary',
              href: { url: href },
            }"
            :class="`${name}__cta`"
          />
        </div>
      </grid-item>
    </grid>
  </a-link-v2>
</template>

<script>
import data from '~/components/molecules/m-cards/m-card-narrow.data'
import ACtaV2 from '~/components/atoms/a-ctas/a-cta-v2'

export default {
  components: { ACtaV2 },
  props: {
    cms: {
      type: Object,
      default() {
        return Object.assign(process.env.NODE_ENV === 'development' ? data : {})
      },
    },
    url: {
      type: String,
      default() {
        return null
      },
    },
    published: {
      type: String,
      default() {
        return ''
      },
    },
    layout: {
      type: Array,
      default() {
        return [{ size: 0, bound: 313, ratio: [315, 212] }]
      },
    },
  },
  data() {
    return {
      name: 'm-card-narrow',
      active: false,
    }
  },
  computed: {
    href() {
      return (
        this.url ||
        (this.cms.href || {}).url ||
        (this.cms.href || {}).cached_url
      )
    },
  },
  methods: {
    onCardHover(boolean) {
      this.active = boolean || false
    },
  },
}
</script>

<style lang="scss" scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.2s ease;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}

.m-card-narrow {
  overflow: hidden;

  ::v-deep a,
  ::v-deep .a-cta {
    color: var(--text-color);
    &:disabled,
    &.disabled {
      color: var(--disabled-color);
    }
  }
  ::v-deep a {
    &:hover,
    &:active {
      color: var(--hover-color);
    }
  }

  ::v-deep .a-cta {
    opacity: 0;
    margin-bottom: 30px;
    &:hover,
    &:active {
      color: var(--text-color);
    }
  }

  &__date {
    @include font-size(14, 24px);

    letter-spacing: 1px;
    padding: 25px 0;
  }

  &__eyebrow {
    @include font-size(16, 28px);

    margin-top: 28px;
  }

  &__heading {
    @include font-family($headings-font-family, 600);
    @include font-size(16, 28px);

    letter-spacing: 1px;
    margin: 0 0 25px;
  }

  &__text {
    ::v-deep p {
      margin: 0 0 30px;
    }
  }

  ::v-deep p,
  ::v-deep img,
  ::v-deep a,
  ::v-deep .a-cta,
  &__tags {
    transition: background-color 0.2s ease-in-out, color 0.2s ease-in-out,
      border 0.2s ease-in-out, 0.8s filter ease-in-out, opacity 0.2s ease-in-out;
  }

  &__link:hover {
    ::v-deep p,
    .m-card-wide__tags {
      color: var(--text-color);
    }
    ::v-deep a {
      opacity: 1;
      color: var(--hover-color);
    }
    ::v-deep .a-cta {
      opacity: 1;
      color: var(--text-color);
    }
  }
}
</style>
